import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "../../utils/toast";

const EventBooking = () => {
  const initialValues = {
    event_type: "",
    name: "",
    phone: "",
    email: "",
    details: "",
  };

  const validationSchema = Yup.object({
    event_type: Yup.string().required("Event Type is required"),
    name: Yup.string().required("Name is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
      .required("Phone number is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    details: Yup.string().required("Description is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APP_DOMAIN}/api/customer/service-inquiry/store`,
        {
          type: "event",
          name: values.name,
          phone: values.phone,
          email: values.email,
          details: values.details,
          event_type: values.event_type,
        },
      );

      if (response.data.status) {
        toast.success("Inquiry sent successfully! We will contact you soon.");
        resetForm();
      } else {
        toast.error(response.data.message || "Failed to send inquiry.");
      }
    } catch (error) {
      console.error("Error sending event inquiry:", error);
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0];
        toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login_formMain booking_formMain">
      <div className="loginForm_inner bookingForm_inner">
        <h2>Plan Your Perfect Event</h2>
        <p className="mb-3">
          Tell us about your event, and we’ll tailor our services to fit your
          needs. We’ll respond within 24-48 hours after you fill out the form.
        </p>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group mb-3">
                <Field as="select" name="event_type" className="form-control">
                  <option value="">Select Event Type</option>
                  <option value="wedding">Wedding</option>
                  <option value="corporate_event">Corporate Event</option>
                  <option value="party">Party</option>
                  <option value="other">Other</option>
                </Field>
                <ErrorMessage
                  name="event_type"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group mb-3">
                <Field
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Name"
                />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group mb-3">
                <Field
                  type="text"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger small"
                />
              </div>
              <div className="form-group mb-3">
                <Field
                  type="text"
                  name="phone"
                  className="form-control"
                  placeholder="Phone"
                />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group mb-4">
                <Field
                  as="textarea"
                  name="details"
                  rows="4"
                  className="form-control"
                  placeholder="Description"
                />
                <ErrorMessage
                  name="details"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="login_btn mb-3">
                <button type="submit" className="btn" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Get a Callback"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EventBooking;
